import commonMapping from "@/mapping/common";

const ddns_provider_list = [
  { value: "NETGEAR", label: "NETGEAR", config: "NETGEAR" },
  { value: "No-IP", label: "www.No-IP.com", config: "no-ip" },
  { value: "Dyn", label: "www.Dyn.com", config: "DynDNS" },
  { value: "3322", label: "www.3322.org", config: "3322" },
  { value: "oray", label: "www.oray.cn", config: "oray" },
];
const have_account_list = [
  { id: "account_yes", value: "yes", config: "1", label: "yes_mark" },
  { id: "account_no", value: "no", config: "0", label: "no_mark" },
];

export const ddns = {
  ddns_enable: commonMapping.intToBoolean,
  ddns_provider: ddns_provider_list,
  "mynetgear.have_account": have_account_list,
  "ddns3322.wildcard_enable": commonMapping.intToBoolean,
};

export default ddns;
